module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAG1BMVEUAAABM2YlL2opM14tL2Yr///+l7MXS9eJ446fBIaQ8AAAABHRSTlMAgL9ARyeO/QAAAMlJREFUKM9l0YENgjAQBdCaOICJTkBcwMQBRBtggWsdAAgD2MoABRnb612hbfgpTXi540grhLgVMqQ8CcxBJvFySaGkgrzkmMOLOtIegt7oMcBT4DYDRkWogNKyIEygAZfeAMAZcB20ARqsNrQY1k+oYQhQ07ue8XFJhSVNYKL9w1MwCvQEIyiCDuENqvaTPFDPFzgOgUpsBkYblYGV/nd5LgKni2M5FXcgXIP8+JAiyKVfLJ9pTOPhLrM8dhe1u8r9ZaNsNcVZiD/g25C13cColgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/image/Bottom/wechat.png
// module id = a2pg
// module chunks = 41